var _path, _g, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26 32h-20c-3.314 0-6-2.686-6-6v-20c0-3.314 2.686-6 6-6h20c3.314 0 6 2.686 6 6v20c0 3.314-2.686 6-6 6z",
    fill: "#f5e6fe"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d9a4fc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.833 8h-5c-.643 0-1.167.523-1.167 1.167v1.667c0 .643.523 1.167 1.167 1.167h5c.644-.001 1.167-.524 1.167-1.168v-1.666c0-.644-.523-1.167-1.167-1.167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.833 14h-5c-.643 0-1.167.523-1.167 1.167v1.667c0 .643.523 1.167 1.167 1.167h5c.644-.001 1.167-.524 1.167-1.168v-1.667c0-.643-.523-1.166-1.167-1.166z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.833 20h-5c-.643 0-1.167.523-1.167 1.167v1.667c0 .643.523 1.167 1.167 1.167h5c.644-.001 1.167-.524 1.167-1.168v-1.667c0-.643-.523-1.166-1.167-1.166z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.167 24h5c.643 0 1.167-.523 1.167-1.167v-13.666c-.001-.644-.524-1.167-1.167-1.167h-5c-.644 0-1.167.523-1.167 1.167v13.667c0 .643.523 1.166 1.167 1.166z",
    fill: "#be63f9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSections);
export default __webpack_public_path__ + "static/media/sections.51e305bc2c8d077dbf80ea67fb401797.svg";
export { ForwardRef as ReactComponent };